import i18n from '../../../../i18n';
import {
  LocalizedLanguage,
  toLocalizedLanguages,
  LocalizedLanguageFormData,
} from './localizedLanguage';

export interface LocalizedString {
  id?: string;
  languages: LocalizedLanguage[];
}

export const toLocalizedString = (
  languages: LocalizedLanguage[]
): LocalizedString => ({
  languages,
});

export const toLocalizedLanguagesFormData = (
  languages: LocalizedLanguage[]
): LocalizedLanguageFormData =>
  Object.entries(languages).reduce((acc, [, { languageCode, value }]) => {
    acc[languageCode] = value;
    return acc;
  }, {} as LocalizedLanguageFormData);

export const formDataToLocalizedString = (
  formData: LocalizedLanguageFormData
): LocalizedString => ({
  languages: toLocalizedLanguages(formData),
});

export const localizedStringToFormData = (
  localizedString: LocalizedString
): LocalizedLanguageFormData =>
  toLocalizedLanguagesFormData(localizedString.languages);

export const getLocalizedValue = (localizedString: LocalizedString): string => {
  const desiredLanguage = localizedString.languages.find(
    (lang) => lang.languageCode === i18n.language
  );

  // Return the value of the desired language or the first available language
  return desiredLanguage
    ? desiredLanguage.value
    : localizedString.languages[0]?.value || '';
};
